// Ported from apps/webapp/src/components/gantt-chart/components/parent-strip.tsx:86-131,
// replacing the hardcoded --color-actions-main-action borders with the depth accent.
// Positioned in the DAY domain (spec §6.1) — see bar.module.scss for the rationale.
//
// DELIBERATELY WITHOUT `--bar-offset-delta`, unlike `bar.module.scss`. That property exists only to
// carry a live preview offset, and `group-bar.tsx` writes NO inline style at all — it has no
// `previewStyle`, and `useBarDrag` there is permanently `disabled` because `isDragDisabledFor`
// short-circuits on `row.isGroup` (spec §8: group rows are not draggable). A group bar's `left` is
// therefore always the track's own `--bar-offset` and there is no second term to add. It is also
// never a DESCENDANT of a `.bar` — `row-list.tsx` renders one or the other as siblings inside the
// `gridcell` — so the delta a dragged leaf bar declares cannot inherit into it.
.groupBar {
  position: absolute;
  top: 50%;
  left: calc(var(--bar-offset) * var(--gantt-px-per-day));
  width: calc(var(--bar-span) * var(--gantt-px-per-day));
  transform: translateY(-50%);
  height: var(--gantt-bar-height);
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.8rem;
  background-color: var(--color-surfaces-app-background-0);
  border-radius: var(--gantt-bar-radius);
  border-inline: var(--border-radius-small, 0.4rem) solid var(--gantt-accent-1);
  user-select: none;
  cursor: default;
  z-index: 4;
  // `transition: width 0.3s, left 0.3s` (parent-strip.tsx:93) is deliberately NOT ported — same
  // decision as `bar.module.scss`. The old module positioned via the parent's CSS-grid column
  // placement, not `left`/`width`, so the transition was inert; porting it literally here would
  // animate `left`/`width`, which are now driven by drag and zoom, adding lag that never shipped.

  &[data-depth='1'] {
    border-inline-color: var(--gantt-accent-2);
  }
}

.left {
  display: flex;
  align-items: center;
  gap: 3.2rem;
  min-width: 0;
}

/* Title, from parent-strip.tsx:126-130 */
.title {
  display: flex;
  align-items: center;
  gap: 0.8rem;
  min-width: 0;
}

.caption {
  font-family: Inter;
  font-size: 1.2rem;
  font-weight: 400;
  line-height: 1.6rem;
  color: var(--color-grayscale-white);
  white-space: nowrap;
}

.dates {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.8rem;
}
